<template>
	<div class="h-nav-links-container">
		<question-search :nosearch="nosearch"></question-search>
		<div class="h-nav-button-lines">
			<div class="h-nav-button-line" v-for="(link, idx) in links" v-if="typeof (link['enabled']) === 'undefined' || link['enabled'] === true">
				<v-btn
						:class="'h-nav-button' + (idx === 0 ? ' ada-focus' : '')"
						block
						large
						round
						:to="link['to']"
						:href="link['url']"
						v-on="link['click'] ? {click: link['click']} : {}"
						v-html="link['caption']"
						role="button"
				>
				</v-btn>
			</div>
		</div>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import QuestionSearch from './QuestionSearch';

	export default {
		name: "BaseNavPage",

		props: {
			links: {
				type: Array,
				default: [],
			},
			nosearch: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {}
		},

		components: {QuestionSearch}
	}
</script>

<style scoped lang="less">
	.h-nav-button-lines {
		/*margin-top: 30px;*/

		.h-nav-button-line {
			margin-bottom: 13px;

			.h-nav-button {
				text-align: center;
				min-height: 50px;
				border-radius: 6px;
				text-transform: none;
				font-size: 13pt;
				font-weight: normal;
			}
		}
	}

	@media  screen and (min-width : 320px) and (max-width : 480px) {
		.h-nav-links-container {
			background-color: #EDF1F4;
			padding: 30px;
			border-radius: 8px;
		}
	}
</style>